import React, { useState} from 'react';
import { SidebarProps as Props } from '../';
import CloseIcon from '../../../../../../../../assets/svg/solo-chat/circle-cross-2.svg';
import style from '../new.module.scss';
import { Editor } from '../../components';

export function AddRecognizes(props: Props) {
	const [isOpen, setIsOpen] = useState(
		props.isEditMode && props.dialog.recognizes?.length > 0,
	);
	return (
		<div className={style.addRecognizes} style={{ marginTop: isOpen ? 16 : 0 }}>
			{!isOpen ? (
				<button className={style.add} onClick={() => setIsOpen(true)}>
					+ Add Recognizes
				</button>
			) : (
				<>
				  <Editor 
					  height="90px"
						value={props.dialog.recognizes}
						onMount={(editor) => {
							editor.focus()
						  props.editorRef.current = editor
						}}
						readOnly={false}
					/>
					<button
						className={style.close}
						onClick={() => {
							props.updateDialogByKey('recognizes', '');
							setIsOpen(false);
						}}
					>
						<img src={CloseIcon} alt="close" />
					</button>
				</>
			)}
		</div>
	);
}
